
import QueryString from 'qs'
import { REACT_APP_BSO_USER_ID, USER_CATEGORY_KEY, USER_ID_KEY } from '../../../../urls'

export const getQueryAllUsers = () => {
    const userID = window.localStorage.getItem(USER_ID_KEY)


    let usersQueryObject = {}

  if (Number(userID) === Number(REACT_APP_BSO_USER_ID)) {
        usersQueryObject = {
        filters: {
            id: {
                $not: userID
            }
                  },
            populate: {
                Type: '*',
                FavoriteList: '*',
                BlackList: '*',
                ContactInfo: '*',
                Settings: '*',
                // {
                //     populate: {
                //         Notifies: '*'
                //     }
                // },
                Documents: {
                    populate: {
                        Type: '*'
                    }
                },

                Viewings: // '*',
                {
                    populate: {
                        Unit: {
                            fields: ['id'],
                            populate: {
                                User: {
                                    fields: ['id']
                                }
                            }
                        }
                    }
                },
                Offers: {
                    populate: {
                        Type: '*',
                        Unit: {
                            fields: ['id'],
                            populate: {
                                User: {
                                    fields: ['id']
                                }
                            }
                        }
                    }
                },
                Units: {
                    populate: {
                        Offers: {
                            fields: ['id'],
                            populate: {
                                User: {
                                    fields: ['id']
                                }
                            }
                        },
                        Viewings: {
                            fields: ['id'],
                            populate: {
                                User: {
                                    fields: ['id']
                                }
                            }
                        },
                        Documents: {
                            fields: ['id'], // , 'Type'
                            populate: {
                                Type: '*'
                            }
                        },
                        Property: '*'
                    }
                },

                Orders: {
                    populate: {
                        Service: '*',
                        Unit: {
                            fields: ['id']
                        }
                    }
                },

                Chats: {
                    populate: {
                        Users:
                        {
                            fields: ['id'],
                            populate: {
                                User: {
                                    fields: ['id']
                                }
                            }
                        },
                        Messages: {
                            populate: {
                                Sender: {
                                    fields: ['id']
                                },
                                Unit:
                                 {
                                     fields: ['id']
                                 }
                            }
                        }
                    }
                }
            }
        }
    }

    const usersQuery = QueryString.stringify(usersQueryObject, { encode: false })
    //  console.log(usersQuery, 'usersQuery')
    return usersQuery
}
